/*
 * @Date: 2023-10-10 11:11:26
 * @Description: cptpp 映射数据
 */
import { getProvinceMeta } from "./utils.js";
const cptppRef = {
  世界月度: {
    title: "世界月度",
    timeApi: "getYears", // 时间获取接口C
    viewsInstance: "world,monthly", // 对应的组件地址
    tableApi: "getWorldTradeMonth",
    exportTableApi: "worldTradeMonth",
    productId: [0],
    timeParam: "C", // 调用方法时使用的参数
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Month",
        timeParamList: ["year", "startMonth", "endYear", "endMonth"],
        isGather: false, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "rgCode",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "1",
          },
          {
            label: "出口",
            value: "2",
          },
          {
            label: "再进口",
            value: "4",
          },
          {
            label: "再出口",
            value: "3",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "TOTAL", // 默认进出口
        options: [],
        paramName: "cmdCode",
        dimensionParamName: "",
        dimensionOptions: [{ label: "HS", value: "" }],
        components: "Goods",
        componentType: "WorldProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "rtCode",
        default: "392,124,36,152,554,702,96,458,704,484,826,604", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "ptCode",
        default: "0", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData",
        className: "w320",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "dateTime",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "rgDescCh",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "rtNameCh",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "ptNameCh",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "cmdCode",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "cmdDescE",
        width: "160",
        func: "",
      },

      {
        label: "金额",
        row: "tradeValue",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "tradeQuantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "计量单位",
        row: "qtDesc",
        width: "160",
        func: "numFormat",
      },
      {
        label: "净重(kg)",
        row: "netWeight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "rgDesc",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "rtCode",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "rtTitle",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "ptCode",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "ptTitle",
        width: "160",
        func: "",
      },
    ],
  },
  世界年度: {
    title: "世界年度",
    timeApi: "getYears", // 时间获取接口C
    timeParam: "C", // 调用方法时使用的参数
    viewsInstance: "world,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear",
    exportTableApi: "worldTradeYear",
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["year", "endYear"],
        components: "Year",
        isGather: false, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "rgCode",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "1",
          },
          {
            label: "出口",
            value: "2",
          },
          {
            label: "再进口",
            value: "4",
          },
          {
            label: "再出口",
            value: "3",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "TOTAL", // 默认进出口
        options: [],
        paramName: "cmdCode",
        dimensionParamName: "dimensionType",
        // useStyle: true,
        dimensionOptions: [
          { label: "HS as reported", value: "hs" },
          { label: "HS 92", value: "h0" },
          { label: "HS 96", value: "h1" },
          { label: "HS 02", value: "h2" },
          { label: "HS 07", value: "h3" },
          { label: "HS 12", value: "h4" },
          { label: "HS 17", value: "h5" },
          { label: "HS 22", value: "h6" },
          { label: "SITC as reported", value: "st" },
          { label: "SITC Rev.1", value: "s1" },
          { label: "SITC Rev.2", value: "s2" },
          { label: "SITC Rev.3", value: "s3" },
          { label: "SITC Rev.4", value: "s4" },
          { label: "BEC", value: "bec" },
        ],
        components: "Goods",
        componentType: "WorldProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "rtCode",
        default: "392,124,36,152,554,702,96,458,704,484,826,604", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "ptCode",
        default: "0", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "yr",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "rgDescCh",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "rtNameCh",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "ptNameCh",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "cmdCode",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "cmdDescE",
        width: "160",
        func: "",
      },

      {
        label: "金额",
        row: "tradeValue",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "tradeQuantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "计量单位",
        row: "qtDesc",
        width: "160",
        func: "numFormat",
      },
      {
        label: "净重(kg)",
        row: "netWeight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "rgDesc",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "rtCode",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "rtTitle",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "ptCode",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "ptTitle",
        width: "160",
        func: "",
      },
    ],
  },
  东盟季度: {
    title: "东盟季度",
    timeApi: "getYears2", // 时间获取接口C
    viewsInstance: "asean,monthly", // 对应的组件地址
    tableApi: "getWorldTradeYear2",
    exportTableApi: "worldTradeYear2",
    timeParam: "Q", // 调用方法时使用的参数
    productId: [0],
    needConcat: true,
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Quarter",
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        useStyle: true,
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "aseanProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "096,458,704,702", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData2",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData2",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  东盟年度: {
    title: "东盟年度",
    timeApi: "getYears2", // 时间获取接口C
    viewsInstance: "asean,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear2",
    exportTableApi: "worldTradeYear2",
    timeParam: "Y", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "endTime"],
        components: "Year",
        isGather: false, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "aseanProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "096,458,704,702", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData2",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData2",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  日本月度: {
    title: "日本月度",
    timeApi: "getYears6", // 时间获取接口C
    viewsInstance: "japan,monthly", // 对应的组件地址
    tableApi: "getWorldTradeYear6",
    exportTableApi: "worldTradeYear6",
    timeParam: "M", // 调用方法时使用的参数
    needConcat: true, // 是否需要拼接year和month的传参
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Month",
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "千日元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "T00", // 默认进出口
        options: [],
        useStyle: true,
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "japanProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "392", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "japanProduction2",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData6",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "第一数量",
        row: "quantity1",
        width: "160",
        func: "",
        align: "right",
      },
      {
        label: "第一计量单位",
        row: "qty_unit1",
        width: "110",
        func: "",
      },
      {
        label: "第二数量",
        row: "quantity2",
        width: "160",
        func: "",
        align: "right",
      },
      {
        label: "第二计量单位",
        row: "qty_unit2",
        width: "110",
        func: "",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  日本年度: {
    title: "日本年度",
    timeApi: "getYears6", // 时间获取接口C
    viewsInstance: "japan,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear6",
    exportTableApi: "worldTradeYear6",
    timeParam: "Y", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "endTime"],
        components: "Year",
        isGather: false, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "千日元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "T00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "japanProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "392", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "japanProduction2",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000,036,124,156,250,276,826,842", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData6",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "第一数量",
        row: "quantity1",
        width: "160",
        func: "",
        align: "right",
      },
      {
        label: "第一计量单位",
        row: "qty_unit1",
        width: "110",
        func: "",
      },
      {
        label: "第二数量",
        row: "quantity2",
        width: "160",
        func: "",
        align: "right",
      },
      {
        label: "第二计量单位",
        row: "qty_unit2",
        width: "110",
        func: "",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  马来西亚月度: {
    title: "马来西亚月度",
    timeApi: "getYears8", // 时间获取接口C
    viewsInstance: "malaysia,monthly", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear8",
    exportTableApi: "worldTradeYear8",
    timeParam: "M", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        components: "Month",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
          {
            label: "本地出口",
            value: "5",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "马来西亚林吉特",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        useStyle: true,
        componentType: "malaysiaProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "458", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData8",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData8",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  马来西亚年度: {
    title: "马来西亚年度",
    timeApi: "getYears8", // 时间获取接口C
    viewsInstance: "malaysia,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear8",
    exportTableApi: "worldTradeYear8",
    timeParam: "Y", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "endTime"],
        components: "Year",
        isGather: false, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
          {
            label: "本地出口",
            value: "5",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "马来西亚林吉特",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "malaysiaProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "458", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData8",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000,036,124,156,250,276,826,842", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData8",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  加拿大本地出口月度: {
    title: "加拿大本地出口月度",
    timeApi: "getYears12", // 时间获取接口C
    viewsInstance: "jnd,monthlyjc", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear12",
    exportTableApi: "worldTradeYear12",
    timeParam: "M", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        components: "Month",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "5", // 默认进出口
        options: [
          {
            label: "本地出口",
            value: "5",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        useStyle: true,
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "jndbcProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "124", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData12bc",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData12bc",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量单位",
        row: "qty_unit",
        width: "160",
        func: "numFormat",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  加拿大进口月度: {
    title: "加拿大进口月度",
    timeApi: "getYears12", // 时间获取接口C
    viewsInstance: "jnd,monthlyj", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear12",
    exportTableApi: "worldTradeYear12",
    timeParam: "M", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        components: "Month",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "2", // 默认进出口
        options: [
          {
            label: "进口",
            value: "2",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        useStyle: true,
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "jndjProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "124", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData12j",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData12j",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量单位",
        row: "qty_unit",
        width: "160",
        func: "numFormat",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  加拿大总出口月度: {
    title: "加拿大总出口月度",
    timeApi: "getYears12", // 时间获取接口C
    viewsInstance: "jnd,monthlyc", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear12",
    exportTableApi: "worldTradeYear12",
    timeParam: "M", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        components: "Month",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "6", // 默认进出口
        options: [
          {
            label: "总出口",
            value: "6",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        useStyle: true,
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "jndzcProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "124", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData12zc",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData12zc",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量单位",
        row: "qty_unit",
        width: "160",
        func: "numFormat",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  智利月度: {
    title: "智利月度",
    timeApi: "getYears10", // 时间获取接口C
    viewsInstance: "zhili,monthly", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear10",
    exportTableApi: "worldTradeYear10",
    timeParam: "M", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        components: "Month",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "T00", // 默认进出口
        options: [],
        paramName: "hsIds",
        useStyle: true,
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "zhiliProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "152", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData10",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData10",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "毛重(kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  智利年度: {
    title: "智利年度",
    timeApi: "getYears10", // 时间获取接口C
    viewsInstance: "zhili,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear10",
    exportTableApi: "worldTradeYear10",
    timeParam: "Y", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "endTime"],
        components: "Year",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "T00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "zhiliProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "152", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData10",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000,036,124,156,250,276,826,842", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData10",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "毛重(kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  秘鲁月度: {
    title: "秘鲁月度",
    timeApi: "getYears9", // 时间获取接口C
    viewsInstance: "bilu,monthly", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear9",
    exportTableApi: "worldTradeYear9",
    timeParam: "M", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        components: "Month",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "1", // 默认进出口
        options: [
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "biluProduction",
        useStyle: true, // 是否使用style，否则用class
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "604", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData9",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData9",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "净重(kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  秘鲁年度: {
    title: "秘鲁年度",
    timeApi: "getYears9", // 时间获取接口C
    viewsInstance: "bilu,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear9",
    exportTableApi: "worldTradeYear9",
    timeParam: "Y", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "endTime"],
        components: "Year",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "1", // 默认进出口
        options: [
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "biluProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "604", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData9",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000,036,124,156,250,276,826,842", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData9",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "净重(kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  新西兰月度: {
    title: "新西兰月度",
    timeApi: "getYears11", // 时间获取接口C
    viewsInstance: "xxl,monthly", // 对应的组件地址
    tableApi: "getWorldTradeYear11",
    needConcat: true,
    exportTableApi: "worldTradeYear11",
    timeParam: "M", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        components: "Month",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
          {
            label: "再出口",
            value: "3",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "新西兰元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "xxlProduction",
        useStyle: true, // 是否使用style，否则用class
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "554", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData11",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData11",
        className: "w320",
        con: {},
      },
      {
        type: "port",
        label: "港口",
        paramName: "portIds",
        default: "NZL000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "xxlport",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量单位",
        row: "qty_unit",
        width: "160",
        func: "numFormat",
      },
      {
        label: "毛重(kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "160",
        func: "",
      },
      {
        label: "伙伴名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  新西兰年度: {
    title: "新西兰年度",
    timeApi: "getYears11", // 时间获取接口C
    viewsInstance: "xxl,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear11",
    exportTableApi: "worldTradeYear11",
    timeParam: "Y", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "endTime"],
        components: "Year",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
          {
            label: "再出口",
            value: "3",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "新西兰元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "xxlProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "554", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData11",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000,036,124,156,250,276,826,842", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData11",
        className: "",
        con: {},
      },
      {
        type: "port",
        label: "港口",
        paramName: "portIds",
        default: "NZL000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "xxlport",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量单位",
        row: "qty_unit",
        width: "160",
        func: "numFormat",
      },
      {
        label: "毛重(kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "160",
        func: "",
      },
      {
        label: "伙伴名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  中国月度: {
    title: "中国月度",
    showOnlyOneChild: true,
    productId: [0],
    viewsInstance: "china,monthly", // 对应的组件地址
    timeApi: "getYears", // 时间获取接口C
    timeParam: "C", // 调用方法时使用的参数
    tableApi: "chinaTradeMonth",
    exportTableApi: "exportChinaTradeMonth",
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        controlDimension: "hsId",
        components: "china-month",
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "3", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "3",
          },
          {
            label: "进口",
            value: "1",
          },
          {
            label: "出口",
            value: "0",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "moneyItype",
        default: "2",
        options: [
          {
            label: "美元",
            value: "2",
          },
          {
            label: "人民币",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "100000", // 默认商品
        options: [],
        paramName: "hsId",
        dimensionParamName: "",
        dimensionOptions: [{ label: "HS", value: "" }],
        components: "Goods",
        componentType: "HaiGuanGoods",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "regionId",
        default: "0", // 默认主体
        options: [],
        // showSelect: config.showSelect || false,   //控制主体是否能选择
        showSelect: true,
        components: "SelectInput",
        componentType: "HaiGuanRegion",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "stateId",
        default: "0", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "HaiGuanState",
        className: "w350",
        con: {},
      },
      {
        type: "way",
        label: "方式",
        paramName: "trademodeId",
        default: "0", // 默认方式
        options: [],
        components: "SelectInput",
        componentType: "Trademode",
        className: "w320",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "dateTime",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "ioreName",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "regionName",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "stateName",
        width: "160",
        func: "",
      },
      {
        label: "方式中文名称",
        row: "trademodeName",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hsId",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hsName",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "moneyAmount",
        width: "160",
        func: "numFormat",
        formatter: "formatColAmount",
        align: "right",
      },
      {
        label: "第一数量",
        row: "amount",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "第一计量单位",
        row: "hsUnitsName",
        width: "160",
        func: "",
      },
      {
        label: "第二数量",
        row: "secondAmount",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "第二计量单位",
        row: "hsUnitsNameTwo",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "regionId",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "stateId",
        width: "160",
        func: "",
      },
      {
        label: "方式编码",
        row: "trademodeId",
        width: "160",
        func: "",
      },
    ],
  },
  韩国月度: {
    title: "韩国月度",
    timeApi: "getYears7", // 时间获取接口C
    viewsInstance: "korea,monthly", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear7",
    exportTableApi: "worldTradeYear7",
    productId: [0],
    timeParam: "M", // 调用方法时使用的参数
    showOnlyOneChild: false,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Month",
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "koreaProduction",
        useStyle: true, // 是否使用style，否则用class
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "410", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData7",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData7",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "净重(kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  韩国年度: {
    title: "韩国年度",
    timeApi: "getYears7", // 时间获取接口C
    viewsInstance: "korea,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear7",
    exportTableApi: "worldTradeYear7",
    productId: [0],
    timeParam: "Y", // 调用方法时使用的参数
    showOnlyOneChild: false,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Year",
        timeParamList: ["startTime", "endTime"],
        isGather: false, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "" }],
        components: "Goods",
        componentType: "koreaProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "410", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData7",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000,036,124,156,250,276,826,842", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData7",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "净重(kg)",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  印尼月度: {
    title: "印尼月度",
    timeApi: "getYears3", // 时间获取接口C
    viewsInstance: "indonesia,monthly", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear3",
    exportTableApi: "worldTradeYear3",
    productId: [0],
    timeParam: "M", // 调用方法时使用的参数
    showOnlyOneChild: false,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Month",
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        className: "w350",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "indonesiaProduction",
        useStyle: true, // 是否使用style，否则用class
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "360", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData3",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData3",
        className: "",
        con: {},
      },
      {
        type: "partner",
        label: "港口",
        paramName: "portIds",
        default: "IDN000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "port",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "港口中文名称",
        row: "port_name_cn",
        width: "160",
        func: "numFormat",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "净重（kg）",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
      {
        label: "港口编码",
        row: "port_id",
        width: "110",
        func: "numFormat",
      },
      {
        label: "港口英文名称",
        row: "port_name_en",
        width: "160",
        func: "numFormat",
      },
    ],
  },
  印尼年度: {
    title: "印尼年度",
    timeApi: "getYears3", // 时间获取接口C
    viewsInstance: "indonesia,annual", // 对应的组件地址
    needConcat: false,
    tableApi: "getWorldTradeYear3",
    exportTableApi: "worldTradeYear3",
    productId: [0],
    timeParam: "Y", // 调用方法时使用的参数
    showOnlyOneChild: false,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Year",
        timeParamList: ["startTime", "endTime"],
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        className: "w350",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "indonesiaProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "360", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData3",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000,036,124,156,250,276,826,842", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData3",
        className: "",
        con: {},
      },
      {
        type: "partner",
        label: "港口",
        paramName: "portIds",
        default: "IDN000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "port",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "港口中文名称",
        row: "port_name_cn",
        width: "160",
        func: "numFormat",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "净重（kg）",
        row: "weight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
      {
        label: "港口编码",
        row: "port_id",
        width: "160",
        func: "numFormat",
      },
      {
        label: "港口英文名称",
        row: "port_name_en",
        width: "160",
        func: "numFormat",
      },
    ],
  },
  菲律宾月度: {
    title: "菲律宾月度（-2023）",
    timeApi: "getYears5", // 时间获取接口C
    viewsInstance: "philippines,monthly", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear5",
    exportTableApi: "worldTradeYear5",
    productId: [0],
    timeParam: "M", // 调用方法时使用的参数
    showOnlyOneChild: false,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Month",
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "",
        dimensionOptions: [{ label: "HS", value: "" }],
        components: "Goods",
        componentType: "philippinesProduction",
        useStyle: true, // 是否使用style，否则用class
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "608", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData5",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData5",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量单位",
        row: "qty_unit",
        width: "160",
        func: "numFormat",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  菲律宾年度: {
    title: "菲律宾年度",
    timeApi: "getYears3", // 时间获取接口C
    viewsInstance: "philippines,annual", // 对应的组件地址
    needConcat: false,
    tableApi: "getWorldTradeYear5",
    exportTableApi: "worldTradeYear5",
    productId: [0],
    timeParam: "Y", // 调用方法时使用的参数
    showOnlyOneChild: false,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Year",
        timeParamList: ["startTime", "endTime"],
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "",
        dimensionOptions: [{ label: "HS", value: "" }],
        components: "Goods",
        componentType: "philippinesProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "608", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData5",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000,036,124,156,250,276,826,842", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData5",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量单位",
        row: "qty_unit",
        width: "160",
        func: "numFormat",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  泰国月度: {
    title: "泰国月度",
    timeApi: "getYears4", // 时间获取接口C
    viewsInstance: "thailand,monthly", // 对应的组件地址
    needConcat: true,
    tableApi: "getWorldTradeYear4",
    exportTableApi: "worldTradeYear4",
    productId: [0],
    timeParam: "M", // 调用方法时使用的参数
    showOnlyOneChild: false,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Month",
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "泰铢",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "thailandProduction",
        useStyle: true,
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "764", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData4",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData4",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量单位",
        row: "qty_unit",
        width: "160",
        func: "numFormat",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  泰国年度: {
    title: "泰国年度",
    timeApi: "getYears4", // 时间获取接口C
    viewsInstance: "thailand,annual", // 对应的组件地址
    needConcat: false,
    tableApi: "getWorldTradeYear4",
    exportTableApi: "worldTradeYear4",
    productId: [0],
    timeParam: "Y", // 调用方法时使用的参数
    showOnlyOneChild: false,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Year",
        timeParamList: ["startTime", "endTime"],
        isGather: false, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "泰铢",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "thailandProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "764", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData4",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000,036,124,156,250,276,826,842", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData4",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "160",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "quantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量单位",
        row: "qty_unit",
        width: "160",
        func: "numFormat",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  文莱季度: {
    title: "文莱季度",
    timeApi: "getYears14", // 时间获取接口C
    viewsInstance: "brunei,monthly", // 对应的组件地址
    tableApi: "getWorldTradeYear14",
    exportTableApi: "worldTradeYear14",
    timeParam: "Q", // 调用方法时使用的参数
    productId: [0],
    needConcat: true,
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Quarter",
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        useStyle: true,
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "tradeBruneiProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "096", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData14",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData14",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  文莱年度: {
    title: "文莱年度",
    timeApi: "getYears14", // 时间获取接口C
    viewsInstance: "brunei,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear14",
    exportTableApi: "worldTradeYear14",
    timeParam: "Y", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "endTime"],
        components: "Year",
        isGather: false, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "tradeBruneiProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "096", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData14",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData14",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  新加坡季度: {
    title: "新加坡季度",
    timeApi: "getYears13", // 时间获取接口C
    viewsInstance: "singapore,monthly", // 对应的组件地址
    tableApi: "getWorldTradeYear13",
    exportTableApi: "worldTradeYear13",
    timeParam: "Q", // 调用方法时使用的参数
    productId: [0],
    needConcat: true,
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Quarter",
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        useStyle: true,
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "SingaporeProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "702", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData13",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData13",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  新加坡年度: {
    title: "新加坡年度",
    timeApi: "getYears13", // 时间获取接口C
    viewsInstance: "singapore,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear13",
    exportTableApi: "worldTradeYear13",
    timeParam: "Y", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "endTime"],
        components: "Year",
        isGather: false, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "SingaporeProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "702", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData13",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData13",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  越南季度: {
    title: "越南季度",
    timeApi: "getYears18", // 时间获取接口C
    viewsInstance: "vietnam,monthly", // 对应的组件地址
    tableApi: "getWorldTradeYear18",
    exportTableApi: "worldTradeYear18",
    timeParam: "Q", // 调用方法时使用的参数
    productId: [0],
    needConcat: true,
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Quarter",
        timeParamList: ["startTime", "startMonth", "endTime", "endMonth"],
        isGather: true, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        useStyle: true,
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "tradeVietnamProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "704", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData18",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData18",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  越南年度: {
    title: "越南年度",
    timeApi: "getYears18", // 时间获取接口C
    viewsInstance: "vietnam,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear18",
    exportTableApi: "worldTradeYear18",
    timeParam: "Y", // 调用方法时使用的参数
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["startTime", "endTime"],
        components: "Year",
        isGather: false, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "ioreId",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "2",
          },
          {
            label: "出口",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "00", // 默认进出口
        options: [],
        paramName: "hsIds",
        dimensionParamName: "dimensionType",
        dimensionOptions: [{ label: "HS", value: "hs" }],
        components: "Goods",
        componentType: "tradeVietnamProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "reporterIds",
        default: "704", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData18",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "partnerIds",
        default: "000", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComRtData18",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "time_id",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "trade_flow",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "reporter_ch",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "partner_ch",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "hs_id",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "hs_name",
        width: "110",
        func: "",
      },
      {
        label: "金额",
        row: "trade_value",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "trade_flow_en",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "reporter_id",
        width: "110",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "reporter_en",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "partner_id",
        width: "110",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "partner_en",
        width: "160",
        func: "",
      },
    ],
  },
  澳大利亚月度: {
    title: "澳大利亚月度",
    timeApi: "getYears19", // 时间获取接口C
    viewsInstance: "australia,monthly", // 对应的组件地址
    tableApi: "getWorldTradeYear19Month",
    exportTableApi: "worldTradeYear19Month",
    productId: [0],
    timeParam: "C", // 调用方法时使用的参数
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Month",
        timeParamList: ["year", "startMonth", "endYear", "endMonth"],
        isGather: false, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "rgCode",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "1",
          },
          {
            label: "出口",
            value: "2",
          },
          {
            label: "再进口",
            value: "4",
          },
          {
            label: "再出口",
            value: "3",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "TOTAL", // 默认进出口
        options: [],
        paramName: "cmdCode",
        dimensionParamName: "",
        dimensionOptions: [{ label: "HS", value: "" }],
        components: "Goods",
        componentType: "tradeAustraliaProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "rtCode",
        default: "36", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData19",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "ptCode",
        default: "0", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData19",
        className: "w320",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "dateTime",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "rgDescCh",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "rtNameCh",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "ptNameCh",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "cmdCode",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "cmdDescE",
        width: "160",
        func: "",
      },

      {
        label: "金额",
        row: "tradeValue",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "tradeQuantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "计量单位",
        row: "qtDesc",
        width: "160",
        func: "numFormat",
      },
      {
        label: "净重(kg)",
        row: "netWeight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "rgDesc",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "rtCode",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "rtTitle",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "ptCode",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "ptTitle",
        width: "160",
        func: "",
      },
    ],
  },
  澳大利亚年度: {
    title: "澳大利亚年度",
    timeApi: "getYears19", // 时间获取接口C
    timeParam: "C", // 调用方法时使用的参数
    viewsInstance: "australia,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear19",
    exportTableApi: "worldTradeYear19",
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["year", "endYear"],
        components: "Year",
        isGather: false, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "rgCode",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "1",
          },
          {
            label: "出口",
            value: "2",
          },
          {
            label: "再进口",
            value: "4",
          },
          {
            label: "再出口",
            value: "3",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "TOTAL", // 默认进出口
        options: [],
        paramName: "cmdCode",
        dimensionParamName: "dimensionType",
        dimensionOptions: [
          { label: "HS as reported", value: "hs" },
          { label: "HS 92", value: "h0" },
          { label: "HS 96", value: "h1" },
          { label: "HS 02", value: "h2" },
          { label: "HS 07", value: "h3" },
          { label: "HS 12", value: "h4" },
          { label: "HS 17", value: "h5" },
          { label: "SITC as reported", value: "st" },
          { label: "SITC Rev.1", value: "s1" },
          { label: "SITC Rev.2", value: "s2" },
          { label: "SITC Rev.3", value: "s3" },
          { label: "SITC Rev.4", value: "s4" },
          { label: "BEC", value: "bec" },
        ],
        components: "Goods",
        componentType: "tradeAustraliaProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "rtCode",
        default: "36", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData19",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "ptCode",
        default: "0", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData19",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "yr",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "rgDescCh",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "rtNameCh",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "ptNameCh",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "cmdCode",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "cmdDescE",
        width: "160",
        func: "",
      },

      {
        label: "金额",
        row: "tradeValue",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "tradeQuantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "计量单位",
        row: "qtDesc",
        width: "160",
        func: "numFormat",
      },
      {
        label: "净重(kg)",
        row: "netWeight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "rgDesc",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "rtCode",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "rtTitle",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "ptCode",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "ptTitle",
        width: "160",
        func: "",
      },
    ],
  },
  英国月度: {
    title: "英国月度",
    timeApi: "getYears21", // 时间获取接口C
    viewsInstance: "australia,monthly", // 对应的组件地址
    tableApi: "getWorldTradeYear21Month",
    exportTableApi: "worldTradeYear21Month",
    productId: [0],
    timeParam: "C", // 调用方法时使用的参数
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Month",
        timeParamList: ["year", "startMonth", "endYear", "endMonth"],
        isGather: false, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "rgCode",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "1",
          },
          {
            label: "出口",
            value: "2",
          },
          {
            label: "再进口",
            value: "4",
          },
          {
            label: "再出口",
            value: "3",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "TOTAL", // 默认进出口
        options: [],
        paramName: "cmdCode",
        dimensionParamName: "",
        dimensionOptions: [{ label: "HS", value: "" }],
        components: "Goods",
        componentType: "tradeUKProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "rtCode",
        default: "826", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData21",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "ptCode",
        default: "0", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData21",
        className: "w320",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "dateTime",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "rgDescCh",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "rtNameCh",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "ptNameCh",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "cmdCode",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "cmdDescE",
        width: "160",
        func: "",
      },

      {
        label: "金额",
        row: "tradeValue",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "tradeQuantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "计量单位",
        row: "qtDesc",
        width: "160",
        func: "numFormat",
      },
      {
        label: "净重(kg)",
        row: "netWeight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "rgDesc",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "rtCode",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "rtTitle",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "ptCode",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "ptTitle",
        width: "160",
        func: "",
      },
    ],
  },
  英国年度: {
    title: "英国年度",
    timeApi: "getYears21", // 时间获取接口C
    timeParam: "C", // 调用方法时使用的参数
    viewsInstance: "australia,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear21",
    exportTableApi: "worldTradeYear21",
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["year", "endYear"],
        components: "Year",
        isGather: false, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "rgCode",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "1",
          },
          {
            label: "出口",
            value: "2",
          },
          {
            label: "再进口",
            value: "4",
          },
          {
            label: "再出口",
            value: "3",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "TOTAL", // 默认进出口
        options: [],
        paramName: "cmdCode",
        dimensionParamName: "dimensionType",
        dimensionOptions: [
          { label: "HS as reported", value: "hs" },
          { label: "HS 92", value: "h0" },
          { label: "HS 96", value: "h1" },
          { label: "HS 02", value: "h2" },
          { label: "HS 07", value: "h3" },
          { label: "HS 12", value: "h4" },
          { label: "HS 17", value: "h5" },
          { label: "SITC as reported", value: "st" },
          { label: "SITC Rev.1", value: "s1" },
          { label: "SITC Rev.2", value: "s2" },
          { label: "SITC Rev.3", value: "s3" },
          { label: "SITC Rev.4", value: "s4" },
          { label: "BEC", value: "bec" },
        ],
        components: "Goods",
        componentType: "tradeUKProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "rtCode",
        default: "826", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData21",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "ptCode",
        default: "0", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData21",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "yr",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "rgDescCh",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "rtNameCh",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "ptNameCh",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "cmdCode",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "cmdDescE",
        width: "160",
        func: "",
      },

      {
        label: "金额",
        row: "tradeValue",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "tradeQuantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "计量单位",
        row: "qtDesc",
        width: "160",
        func: "numFormat",
      },
      {
        label: "净重(kg)",
        row: "netWeight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "rgDesc",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "rtCode",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "rtTitle",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "ptCode",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "ptTitle",
        width: "160",
        func: "",
      },
    ],
  },
  墨西哥月度: {
    title: "墨西哥月度",
    timeApi: "getYears20", // 时间获取接口C
    viewsInstance: "mexcico,monthly", // 对应的组件地址
    tableApi: "getWorldTradeYear20Month",
    exportTableApi: "worldTradeYear20Month",
    productId: [0],
    timeParam: "C", // 调用方法时使用的参数
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        components: "Month",
        timeParamList: ["year", "startMonth", "endYear", "endMonth"],
        isGather: false, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "rgCode",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "1",
          },
          {
            label: "出口",
            value: "2",
          },
          {
            label: "再进口",
            value: "4",
          },
          {
            label: "再出口",
            value: "3",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "TOTAL", // 默认进出口
        options: [],
        paramName: "cmdCode",
        dimensionParamName: "",
        dimensionOptions: [{ label: "HS", value: "" }],
        components: "Goods",
        componentType: "tradeMexcicoProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "rtCode",
        default: "484", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData20",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "ptCode",
        default: "0", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData20",
        className: "w320",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "dateTime",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "rgDescCh",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "rtNameCh",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "ptNameCh",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "cmdCode",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "cmdDescE",
        width: "160",
        func: "",
      },

      {
        label: "金额",
        row: "tradeValue",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "tradeQuantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "计量单位",
        row: "qtDesc",
        width: "160",
        func: "numFormat",
      },
      {
        label: "净重(kg)",
        row: "netWeight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "rgDesc",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "rtCode",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "rtTitle",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "ptCode",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "ptTitle",
        width: "160",
        func: "",
      },
    ],
  },
  墨西哥年度: {
    title: "墨西哥年度",
    timeApi: "getYears20", // 时间获取接口C
    timeParam: "C", // 调用方法时使用的参数
    viewsInstance: "mexcico,annual", // 对应的组件地址
    tableApi: "getWorldTradeYear20",
    exportTableApi: "worldTradeYear20",
    productId: [0],
    showOnlyOneChild: true,
    topControlList: [
      // 上方控制点
      {
        type: "time", //控制点类型
        label: "时间", //标签
        default: "",
        options: [],
        timeParamList: ["year", "endYear"],
        components: "Year",
        isGather: false, // 是否可汇总
        con: {},
      },
      {
        type: "flow",
        label: "流向",
        paramName: "rgCode",
        default: "0", // 默认进出口
        options: [
          {
            label: "进出口",
            value: "0",
          },
          {
            label: "进口",
            value: "1",
          },
          {
            label: "出口",
            value: "2",
          },
          {
            label: "再进口",
            value: "4",
          },
          {
            label: "再出口",
            value: "3",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
      {
        type: "coin",
        label: "币制",
        paramName: "bizih",
        default: "1",
        options: [
          {
            label: "美元",
            value: "1",
          },
        ],
        components: "SelectRadio",
        con: {},
      },
    ],
    bottomControlList: [
      // 下方控制点
      {
        type: "goods",
        label: "商品",
        default: "TOTAL", // 默认进出口
        options: [],
        paramName: "cmdCode",
        dimensionParamName: "dimensionType",
        dimensionOptions: [
          { label: "HS as reported", value: "hs" },
          { label: "HS 92", value: "h0" },
          { label: "HS 96", value: "h1" },
          { label: "HS 02", value: "h2" },
          { label: "HS 07", value: "h3" },
          { label: "HS 12", value: "h4" },
          { label: "HS 17", value: "h5" },
          { label: "SITC as reported", value: "st" },
          { label: "SITC Rev.1", value: "s1" },
          { label: "SITC Rev.2", value: "s2" },
          { label: "SITC Rev.3", value: "s3" },
          { label: "SITC Rev.4", value: "s4" },
          { label: "BEC", value: "bec" },
        ],
        components: "Goods",
        componentType: "tradeMexcicoProduction",
        con: {},
      },
      {
        type: "mainbody",
        label: "主体",
        paramName: "rtCode",
        default: "484", // 默认主体
        options: [],
        components: "SelectInput",
        componentType: "ComRtData20",
        className: "w440",
        con: {},
      },
      {
        type: "partner",
        label: "伙伴",
        paramName: "ptCode",
        default: "0", // 默认伙伴
        options: [],
        components: "SelectInput",
        componentType: "ComPtData20",
        className: "",
        con: {},
      },
    ],
    tableList: [
      {
        label: "时间",
        row: "yr",
        width: "110",
        func: "",
      },
      {
        label: "流向中文名称",
        row: "rgDescCh",
        width: "160",
        func: "",
      },
      {
        label: "主体中文名称",
        row: "rtNameCh",
        width: "160",
        func: "",
      },
      {
        label: "伙伴中文名称",
        row: "ptNameCh",
        width: "160",
        func: "",
      },
      {
        label: "商品编码",
        row: "cmdCode",
        width: "110",
        func: "",
      },
      {
        label: "商品名称",
        row: "cmdDescE",
        width: "160",
        func: "",
      },

      {
        label: "金额",
        row: "tradeValue",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "数量",
        row: "tradeQuantity",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "计量单位",
        row: "qtDesc",
        width: "160",
        func: "numFormat",
      },
      {
        label: "净重(kg)",
        row: "netWeight",
        width: "160",
        func: "numFormat",
        align: "right",
      },
      {
        label: "流向英文名称",
        row: "rgDesc",
        width: "160",
        func: "",
      },
      {
        label: "主体编码",
        row: "rtCode",
        width: "160",
        func: "",
      },
      {
        label: "主体英文名称",
        row: "rtTitle",
        width: "160",
        func: "",
      },
      {
        label: "伙伴编码",
        row: "ptCode",
        width: "160",
        func: "",
      },
      {
        label: "伙伴英文名称",
        row: "ptTitle",
        width: "160",
        func: "",
      },
    ],
  },
};
export { cptppRef };
